<template>
    <div class="wrapper">
        <div class="sidebar column">
            <section id="upper-menu">
                <!-- UPPER MENU -->
                <div class="logo">
                    <img src="~@/assets/images/dash_logo.png" @click="logoutFromAccount()" class="clickable">
                </div>

                <section v-if="identification">
                    <side-bar-menu-item  title="Account" icon="business" :route="homeRoute"/>
                    <side-bar-menu-item  title="Settings" icon="settings" :route="settingsRoute"/>
                    <side-bar-menu-item  title="Statistics" icon="timeline" :route="statisticsRoute"
                                        v-if="requiresRight(this.$parleyAdmin.auth.getRightsList().GetStatistics.id)"
                    />
                    <side-bar-menu-item  title="Users" icon="people_outline" :route="usersRoute"
                                        v-if="requiresRight(this.$parleyAdmin.auth.getRightsList().SearchUsersInAccount.id)"
                    />
                </section>
            </section>

            <section id="bottom-menu">
                <!-- BOTTOM MENU -->
                <!--<div class="logout" v-on:click="logoutClick">-->
                <!--<i class="material-icons">power_settings_new</i>-->
                <!--</div>-->

                <div class="profile-settings-icon">
                    <b-dropdown dropup no-caret variant="link" offset="25" menu-class="menu">
                        <template slot="button-content">
                            <img class="avatar" :src="avatar">
                        </template>
                        <b-dropdown-item v-for="profileMenuOption in profileMenuOptions"
                                       :key="profileMenuOption.text"
                                       @click="profileMenuOption.click"
                                       class="menu-item"
                        >{{ profileMenuOption.text }}
                        </b-dropdown-item>
                    </b-dropdown>
                </div>
            </section>

        </div>

        <!-- This modal is temporary for logging out. TODO: Design the logout flow -->
        <modal ref="logoutModal" class="logoutModal">
            <div slot="modal-header">
                Logout
            </div>
            <div slot="modal-content">
                <p>Are you sure you want to logout?</p>
            </div>
            <div slot="modal-footer" class="footer">
                <button class="secondary" v-on:click="closeModal('logoutModal')">Cancel</button>
                <button class="primary" v-on:click="logout">Logout</button>
            </div>
        </modal>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';
import sideBarMenuItem from './additional/sidebarMenuItem';
import modal from '@/components/additional/modal.vue';
import ClickOutside from 'vue-click-outside';

export default {
    components: {
        sideBarMenuItem,
        modal,
    },
    directives: {
        ClickOutside
    },
    name: 'sidebar',
    mixins: [
        Default
    ],
    data() {
        return {
            settingsAccounts: null,
            settingsGeneral: null,
            profileMenuOptions: {
                settings: {
                    text: 'settings',
                    click: () => { this.$router.push({name: 'profile'}); }
                },
                logout: {
                    text: 'logout',
                    click: () => { this.logoutClick(); }
                }
            }
        };
    },
    computed: {
        avatar: {
            get() {
                const avatar = this.$store.getters[this.$store.types.user.getters.get].avatar;
                return avatar || 'http://www.gravatar.com/avatar';
            }
        },
        identification: {
            get() {
                return this.$store.getters[this.$store.types.loggedinAccount.getters.get].identification;
            }
        },
        hasAccessToMultipleAccounts: {
            get() {
                return this.$store.getters[this.$store.types.user.getters.get].hasAccessToMultipleAccounts;
            }
        },
        homeRoute: {
            get() {
                return {name: 'home', params: {'identification': this.identification}};
            }
        },
        settingsRoute: {
            get() {
                return {name: 'settings', params: {'identification': this.identification}};
            }
        },
        statisticsRoute: {
            get() {
                return {name: 'statistics', params: {'identification': this.identification}};
            }
        },
        usersRoute: {
            get() {
                return {name: 'users', params: {'identification': this.identification}};
            }
        }
    },
    methods: {
        logoutClick: function() {
            this.$refs['logoutModal'].openModal();
        },
        logout: async function() { // Logs a user out of the system
            await this.$parleyAdmin.auth.logoutUser();
            this.closeModal('logoutModal');

            this.$router.push({name: 'login'}); // Go to login page
        },
        logoutFromAccount: async function() {
            await this.$parleyAdmin.auth.logoutAccount();
            this.$router.push({name: 'accountsList'});
        },
        closeModal: function(modalRef) {
            this.$refs[modalRef].closeModal();
        }
    }
};
</script>

<style lang="scss" scoped>
    .sidebar {
        height: 100vh;
        min-width: $widthSidebar;
        background-color: #454d5a;
        padding-top: 20px;
        text-align: center;

        .sidebar-icon {
            padding-top: 50px;
        }

        .logo {
            margin-bottom: 5em;

            .clickable {
                cursor: pointer;
            }
        }

        #upper-menu {
            height: auto; //30em;
        }

        #bottom-menu {
            margin: .5em 0;
            position: absolute;
            bottom: 0;
            width: $widthSidebar;

            .logout {
                i {
                    margin: .5em;
                    color: white;
                    font-size: 1.8em;
                    cursor: pointer;

                    &:hover {
                        color: $primary-color;
                    }
                }
            }

            .profile-settings-icon {
                position: relative;
                margin: 1em 0;

                img {
                    border-radius: 50%;
                    height: 45px;
                    width: 45px;
                    cursor: pointer;
                }
                i {
                    color: white;
                    padding: 3px;
                    position: absolute;
                    bottom: 30px;
                    right: 6px;
                    background-color: #454d5a;
                    border-radius: 50%;
                    border-width: 5px;
                    font-size: 16px;
                }

                .menu-item:hover {
                    background-color: $primary-color;
                    color: white;
                }


                .menu-enter-active, .menu-leave-active {
                    transition: all 1s;
                }
                .menu-enter, .menu-leave-to {
                    opacity: 0;
                    transform: translateY(30px);
                }
            }
        }
    }
</style>

<style lang="scss">
    .profile-settings-icon {
        .menu {
            padding: 0;
        }

        .btn { // Reset padding for bootstrap-vue dropdown button
            padding: 0;
        }
    }
</style>
